// Acceso a la biblioteca de 1.324 ejercicios de public/data/exercises.json.
//
// El fichero pesa unos 2 MB, así que se carga bajo demanda —al abrir la
// biblioteca o al pedir el detalle de un ejercicio— y se cachea en memoria.
// Las peticiones simultáneas comparten la misma promesa para no descargarlo
// dos veces.

let cache = null;
let inFlight = null;
let byId = null;

export function loadLibrary() {
  if (cache) return Promise.resolve(cache);
  if (inFlight) return inFlight;

  inFlight = fetch("/data/exercises.json")
    .then((res) => {
      if (!res.ok) throw new Error("No se pudo cargar la biblioteca de ejercicios");
      return res.json();
    })
    .then((data) => {
      cache = data;
      byId = new Map(data.map((ex) => [ex.id, ex]));
      return data;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

export async function getExerciseById(id) {
  if (!id) return null;
  await loadLibrary();
  return byId.get(id) || null;
}

// Nombre visible: la biblioteca trae el original en inglés y la traducción.
export function displayName(ex) {
  return ex.nameEs || ex.name;
}

export async function getFilters() {
  const data = await loadLibrary();
  return {
    bodyParts: [...new Set(data.map((e) => e.bodyPart))].filter(Boolean).sort(),
    equipment: [...new Set(data.map((e) => e.equipment))].filter(Boolean).sort(),
  };
}

// Busca en nombre traducido, nombre original y grupo muscular, para que
// "pecho", "bench" y "press banca" encuentren todos algo razonable.
export function searchExercises(data, { query = "", bodyPart = null, equipment = null } = {}) {
  const q = query.trim().toLowerCase();

  return data.filter((ex) => {
    if (bodyPart && ex.bodyPart !== bodyPart) return false;
    if (equipment && ex.equipment !== equipment) return false;
    if (!q) return true;
    return (
      (ex.nameEs || "").toLowerCase().includes(q) ||
      (ex.name || "").toLowerCase().includes(q) ||
      (ex.muscleGroup || "").toLowerCase().includes(q) ||
      (ex.bodyPart || "").toLowerCase().includes(q)
    );
  });
}

// Convierte una entrada de la biblioteca en un ejercicio de la rutina.
export function toRoutineExercise(ex, { id, sets = 3, reps = "10-12" } = {}) {
  return {
    id,
    libraryId: ex.id,
    name: displayName(ex),
    muscleGroup: ex.muscleGroup || ex.bodyPart,
    sets,
    reps,
    img: ex.gifUrl,
  };
}
